<div class="flex items-center gap-5">
  @for (item of socialMediaLinks(); track item.id) {
    <app-external-link [link]="item.link">
      <app-footer-icon [icon]="item.icon" />
    </app-external-link>
  }
</div>
